export default {
  header: {
    title: 'Recompensas',
  },
  content: {
    title: 'Tem {{balance}} pontos',
    description: 'Gaste {{amount}}, ganhe {{rewards}} pontos! Adicione itens grátis ao carrinho com os seus pontos.',
    articles: {
      title: 'Ganhe pontos com cada pedido',
      spend_description: 'Por cada {{amount}} gasto, ganhe {{rewards}} pontos na sua conta.',
      redeem_title: 'Resgate os seus pontos',
      redeem_description:
        'Troque pontos por brindes grátis! Resgate recompensas a partir de {{minSpendingLimit}} pontos, equivalente a {{amount}} em compras',
      discounts_title: 'Descubra vantagens exclusivas',
      discounts_description: 'Desbloqueie ofertas, promoções e descontos exclusivos.',
    },
  },
};
